import Drawer from 'react-modern-drawer';
import { useEffect, useState } from "react";
import { CommonUtilities } from 'commonUtils';
import ButtonsLabelsInputs from 'components/Templates/ButtonsLabelsInputs';

export default function ProductionUpsert(param: any) {

    let [savedStatus, setSavedStatus] = useState(true);
    let [advanceStatus, setAdvanceStatus] = useState(false);
    let [filterSelection, SetFilterSelection] = useState<any>([]);

    const onCloseDrawer = () => {

        console.log("E")
        console.log(filterSelection)

        if (savedStatus == false) {
            CommonUtilities.showToastDawer('Some data unsave', 'fail')
        } else {
            param.productionUpsertChange();
        }
    }

    useEffect(() => {
        const handleEsc = (e: any) => {
            if (e.key === 'Escape') {
                onCloseDrawer();
            }
        };

        document.addEventListener('keydown', handleEsc);


        console.log(param)

        filterSelection = param.productionSelected;
        SetFilterSelection(filterSelection)

        return () => {
            document.removeEventListener('keydown', handleEsc);
        };
    }, [onCloseDrawer]);

    const saveChange = () => {

        savedStatus = true;
        setSavedStatus(savedStatus)
        param.productionUpsertChange("saved");
    }



    let [yearOption, SetYearOption] = useState<any>([]);
    useEffect(() => {
        const startYear = 1990;
        const currentYear = new Date().getFullYear();

        const years = Array.from(
            { length: currentYear - startYear + 1 },
            (_, i) => currentYear - i
        );

        console.log(years)

        yearOption = years;
        SetYearOption(yearOption)
        console.log(yearOption)
    }, [])
    return (
        <Drawer open={param.productionUpsertOpen}
            onClose={onCloseDrawer}
            direction='right'
            className='react-drawer  allowHscroll allowVscroll'
            size={800}>

            <div className="box noBorderRadius noBorder ws-4 pull-right full-height-vh">

                <div className='ws-12 pm' >

                    <div className='ws-10'>
                        <h1 className='text-bold'> Create New Production</h1>
                        <span className=' ptl'>Add core production details to begin capturing casts and cues.</span>
                    </div>

                    <button onClick={() => onCloseDrawer()} className="btn-xxs  borderNone bgTransparent pull-right mtxl"  >
                        <i className="icon-close3 danger"></i>
                    </button>
                </div>

                <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>

                <div className='ws-11 paddingCenterBox pLarge'>

                    <div className='ws-12 pm'>
                        <label className='text-bold ws-12'> Production Title *</label>
                        <input className='ws-12' onChange={(e) => { SetFilterSelection({ ...filterSelection, productionTitle: e.target.value, }); setSavedStatus(false) }} value={filterSelection?.productionTitle ?? ""} />
                        <h3 className='grey mt ws-12'>Official production title as credited.</h3>
                    </div>

                    <div className='ws-12 pm'>
                        <label className='text-bold ws-12'> Production Type *</label>
                        <select className='ws-12' onChange={(e) => { SetFilterSelection({ ...filterSelection, type: e.target.value, }); setSavedStatus(false) }} value={filterSelection?.type ?? ""}>
                            <option>Film</option>
                            <option>Television </option>
                            <option>Series </option>
                            <option>Theatre </option>
                            <option>Commercial </option>
                            <option>Other </option>
                        </select>
                    </div>

                    <div className='ws-12 pm'>
                        <label className='text-bold'> Programme Number</label>
                        <input className='ws-12' onChange={(e) => { SetFilterSelection({ ...filterSelection, programmeNumber: e.target.value, }) }} value={filterSelection?.programmeNumber ?? ""} />
                    </div>

                    <div className='ws-12 pm'>
                        <label className='text-bold ws-12'>Producer / Broadcaster</label>
                        <input className='ws-12' placeholder="Select or add producer / broapcaster " onChange={(e) => { SetFilterSelection({ ...filterSelection, producerBroadcaster: e.target.value, }); setSavedStatus(false) }} value={filterSelection?.producerBroadcaster ?? ""} />

                    </div>

                    <div className='ws-12 pm'>
                        <label className='text-bold'>Year of First Release *</label>

                        <select className='ws-12' value={filterSelection?.year ?? ""} onChange={(e: any) => { SetFilterSelection({ ...filterSelection, releaseYear: e.target.value, }); setSavedStatus(false) }}  >
                            <option> All Years</option>
                            {
                                yearOption?.map((vales: any) => {
                                    return (<option value={vales}> {vales}  </option>)
                                })
                            }
                        </select>
                    </div>

                    <div className='ws-12 pm'>
                        <label className='text-bold'>Production Status</label>
                        <select className='ws-12' onChange={(e) => { SetFilterSelection({ ...filterSelection, productionNumber: e.target.value, }); setSavedStatus(false) }} value={filterSelection?.year ?? ""}>
                            <option>Draft </option>
                        </select>
                    </div>

                    <div className='ws-12 pm hide'>
                        <h3 className='ws-10 text-bold grey'>Notes (optional)</h3>
                        <h3 className='ws-10 text-bold grey'>Internal notes only. Not visible to members.</h3>
                    </div>

                </div>

                <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>

                <div className='ws-12 ps'>
                    <span className='black pt ws-9 pll text-l ' onClick={() => setAdvanceStatus(!advanceStatus)}> <i className='icon-angle-right text-l text-bold mrl'></i> Advanced details </span>
                    <button className='ws-2 borderNone pull-right btn-xl noOutline' onClick={() => setAdvanceStatus(!advanceStatus)}>
                        <i className={advanceStatus ? 'icon-angle-down pull-right' : 'icon-angle-up pull-right'}></i>
                    </button>
                </div>

                {advanceStatus && <div className='ws-12 prxl plxl'>
                    <div className='ws-12 pm'>
                        <label className='text-bold ws-12'> ISAN</label>
                        <input className='ws-12' onChange={(e) => { SetFilterSelection({ ...filterSelection, ISAN: e.target.value, }); setSavedStatus(false) }} />
                    </div>

                    <div className='ws-12 pm'>
                        <label className='text-bold ws-12'> Alternate titles</label>
                        <input className='ws-12' onChange={(e) => { SetFilterSelection({ ...filterSelection, Alternatetitles: e.target.value, }); setSavedStatus(false) }} />
                    </div>

                    <div className='ws-12 pm'>
                        <label className='text-bold ws-12'> Territory</label>
                        <input className='ws-12' onChange={(e) => { SetFilterSelection({ ...filterSelection, Territory: e.target.value, }); setSavedStatus(false) }} />
                    </div>

                    <div className='ws-12 pm'>
                        <label className='text-bold ws-12'> Rights start date</label>
                        <input className='ws-12' onChange={(e) => { SetFilterSelection({ ...filterSelection, Rightsstartdate: e.target.value, }); setSavedStatus(false) }} />
                    </div>
                </div>}

                <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>

                <div className='ws-12 pm  '>
                    <button type="button" className=" icon-btn info text-bold pull-left height40 ml hide">Import Production</button>
                    <button type="button" className=" icon-btn close text-bold pull-left height40 width100" onClick={() => onCloseDrawer()}>Cancel</button>

                    <button type="button" className=" icon-btn close text-bold pull-right height40 width100 hide" onClick={() => onCloseDrawer()}>Close</button>
                    <button type="button" className=" icon-btn edit  text-bold pull-right height40 width100" onClick={() => saveChange()}>Save</button>
                </div>

            </div>

        </Drawer>

    )
}